import React from "react";
import PropTypes from "prop-types";
import { Add } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import RoleButton from "../RoleButton";
import { BUTTON_TYPES } from "../../../config/permissions";

/**
 * Role-based AddButton
 *
 * This component combines RoleButton logic with a styled Add icon button.
 * It hides or disables itself based on the user's roles and defined permissions.
 */
const AddButton = ({
  title,
  onClick,
  isDisabled = false,
  roleComponent, 
}) => {
  return (
    <RoleButton
      roleButtonType={BUTTON_TYPES.ADD}
      roleComponent={roleComponent}
      roleIsIconBtn
      tooltip={`You don't have permission to add ${title}`}
      withTooltip={`Add ${title}`}
      color="primary"
      onClick={onClick}
      sx={{
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: 60,
        width: 60,
        boxShadow: "0 6px 20px rgba(25, 118, 210, 0.4)",
        border: "1px solid rgba(255, 255, 255, 0.24)",
        borderRadius: 1,
        transition: "0.2s ease",
        color: "primary.main",
        "&:hover": {
          boxShadow: 5,
          color: "primary.light",
          backgroundColor: "action.hover",
        },
      }}
      disabled={isDisabled}
    >
      <Add sx={{ fontSize: 35 }} />
    </RoleButton>
  );
};

AddButton.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  roleComponent: PropTypes.string.isRequired, 
};

export default AddButton;
